import { AppStore } from '@apparatix/stores/AppStore';
export const useBackendDataConverter = () => {
    const generateUrl = (isIframed, url) => {
        if (isIframed) {
            return url;
        }
        return `/iframe-wrapper${url}`;
    };
    const navigationObjectToTopLevelNavigation = (navObject) => {
        const topMenuItems = [];
        Object.entries(navObject).forEach(([key, value]) => {
            if (Object.hasOwn(navObject, key)) {
                if (!Array.isArray(value))
                    return;
                if (key === 'Unused_Items')
                    return;
                const parentUuid = crypto.randomUUID();
                const childItems = [];
                value.forEach(item => {
                    const isIframed = item.iframed === 1;
                    const menuItem = {
                        label: item.mui_title?.replace('&amp;', '&'),
                        uuid: crypto.randomUUID(),
                        isHomePage: item.mui_title === item.mui_folder,
                        isIframed: isIframed,
                        url: generateUrl(isIframed, item.mui_url),
                        parentUuid: parentUuid,
                    };
                    menuItem.command = () => {
                        AppStore.setActiveSubPage(menuItem);
                    };
                    childItems.push(menuItem);
                });
                if (!childItems.find(item => item.isHomePage)) {
                    const homeItem = {
                        label: 'Home',
                        uuid: crypto.randomUUID(),
                        url: '',
                        parentUuid: parentUuid,
                        isHomePage: true,
                        isCategoryHome: true,
                    };
                    homeItem.command = () => {
                        AppStore.setActiveSubPage(homeItem);
                        AppStore.showPageNotImplemented = false;
                    };
                    childItems.unshift(homeItem);
                }
                const topMenuItem = {
                    label: key,
                    uuid: parentUuid,
                    children: childItems,
                };
                if (key === 'CORE') {
                    topMenuItem.shouldShowSidebar = false;
                }
                else {
                    topMenuItem.shouldShowSidebar = true;
                }
                topMenuItem.command = () => AppStore.setActivePage(topMenuItem);
                topMenuItems.push(topMenuItem);
            }
        });
        topMenuItems.push({
            label: 'TAG',
            uuid: crypto.randomUUID(),
            children: [],
            icon: 'externalLink',
            command: () => {
                const { email } = AppStore.currentUser;
                const url = `${window.location.protocol}//${window.location.hostname}/sso/index.html?a=li&address=${email}`;
                window.open(url, '_blank');
            },
        });
        return topMenuItems;
    };
    return { navigationObjectToTopLevelNavigation };
};
